
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { WorkflowService } from "../services/workflow-service";
import { NotifyService } from "../services/notify-service";

export interface IStatusHistoryScope extends ng.IScope {
	entityId: string;
}

export function StatusHistory(): ng.IDirective {
	return {
		restrict: 'EA',
		template: require("/assets/app/templates/status-history.html"),
		scope: {
			entityId: "@"
		},
		controller: StatusHistoryController,
		bindToController: true,
		controllerAs: 'shVM',
		link: (scope: IStatusHistoryScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any) => {
		}
	}
}

export class StatusHistoryController {
	static $inject = ["$window", "$scope", "workflowService", "notifyService"];

	entityId: string;

	statusHistoryItems: Models.IStatusHistoryItem[];

	constructor(
		private $window: ng.IWindowService,
		private $scope: ng.IScope,
		private workflowService: WorkflowService,
		private notifyService: NotifyService) {

		this.statusHistoryItems = [];                       // NEW

		$scope.$watch(() => this.entityId, (newValue, oldValue) => {
			if (newValue) {
				this.Init();
			}
		});

		this.$scope.$on(Consts.Events.UpdateStatusHistory, (e, data) => {
			if (!_.isEmpty(data)) {
				this.Init();
			}
		});
	}

	Init() {
		this.notifyService.startProgress();
		this.workflowService.getEntityStatusHistory(this.entityId)
			.then((results) => {
				this.statusHistoryItems = results;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}
}

